import {DigitalRevisionMenuItem} from '../interfaces/digital-revision-menu-item';
import {ProxyTypeEnum} from '../interfaces/proxy-type-enum';
import {MenuItemTypeEnum} from '../interfaces/menu-item-type-enum';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a quick quiz',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/AWHR43/AWHR43_QuickQuiz_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Quick Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>Test yourself with quizzes covering every poem. On your marks, get set... quiz!</p>\n' +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Questions on every poem',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Flashcards',
        ImagePath: '/assets/images/landing/flashcards.png',
        DestinationPage: 'Flashcards',
      },
      {
        Text: 'Poetry Readings',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Poetry-Readings',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to mistakes quiz',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/AWHR43/AWHR43_WA_v1',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>The quick quiz questions you got wrong are here — have another go and conquer them once and for all!</p>\n' +
      '\n' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Flashcards',
        ImagePath: '/assets/images/landing/flashcards.png',
        DestinationPage: 'Flashcards',
      },
      {
        Text: 'Poetry Readings',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Poetry-Readings',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      IntroTitle: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.QuotationFlashcards,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Flashcards',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/AWHR43/2720_AWHR43_Flashcards_v4',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: false,
    HeadingText: 'Flashcards',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Key quotes on the front and helpful analysis on the back.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Speedy on-the-go revision',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Flashcards',
        ImagePath: '/assets/images/landing/flashcards.png',
        DestinationPage: 'Flashcards',
      },
      {
        Text: 'Poetry Readings',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Poetry-Readings',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      IntroTitle: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.PoetryReadings,
    IsFreeSample: false,
    IconPath: '/assets/images/landing/practice-audio.png',
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Listen now',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Poetry Readings',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Turn up your speakers and select the poem you want to listen to — a treat for the ears!</p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'The poems read aloud',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Flashcards',
        ImagePath: '/assets/images/landing/flashcards.png',
        DestinationPage: 'Flashcards',
      },
      {
        Text: 'Poetry Readings',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Poetry-Readings',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Poetry Readings',
      Intro:
        'Time to get into the poetry zone! Turn up your speakers and then select the poem you want to listen to.',
      ProductTitle: 'GCSE WJEC English Literature',
      AdditionalInfo:
        '<p>CGP would like to thank the copyright holders for permission to reproduce material — you\'ll find more information <a href="[[cloudfront_url]]/_revisionhub_opc/AWHR43/PDF/AWHR43_Audio_Acknowledgements.pdf" target="_blank">here</a>.</p>' +
        '<p><strong>Disclaimer:</strong><br>' +
        "For copyright reasons, we're unable to provide an audio file for —Decomposition — by Zulfikar Ghose.  But don't fear — other readings of this poem can easily be found online.</p>",
      TrackFilePaths: [
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/blackberry-picking-heaney.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/catrin-clarke.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/cousin-kate-rossetti.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/disabled-owen.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/drummer-hodge-hardy.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/dusting-the-phone-kay.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/i-shall-return-mckay.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/i-wandered-lonely-as-a-cloud-wordsworth.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/kamikaze-garland.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/origin-story-ewing.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/remains-armitage.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/sonnet-29-barrett-browning.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/the-schoolboy-blake.mp3',
        '[[cloudfront_url]]/_revisionhub_opc/AWHR43/Audio/war-photographer-duffy.mp3',
      ],
    },
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Products',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your e-Book here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Watch our useful video to get started or take a look at the FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        "We've put together lots of helpful information on how to get the most out of your Poetry Anthology. And if you've hit any snags, you'll find the answers you need here too. ",
      Text:
        ' <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5>What is CGP RevisionHub?</h5>\n' +
        '\n' +
        "<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE English Poetry Anthology. Use the quizzes, flashcards and more to revise what you've learned from your book and prepare for the exams.</p>\n" +
        '\n' +
        '<h5>How do I access CGP RevisionHub?</h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.</p>\n' +
        '\n' +
        '<h5>How do I use CGP RevisionHub with my book?</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Give them a scan and you'll automatically be taken to the relevant test, video or other revision thingy-ma-jig so you can go over what you've learned!</p>\n" +
        '\n' +
        "<h5>My CGP RevisionHub isn't working — what do I do?</h5>\n" +
        '\n' +
        "<p>If you can't find the answer in these FAQs, it's time to contact our friendly Customer Services team.</p>\n" +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...</p>\n' +
        '\n' +
        '<h5>Do I need an internet connection to use CGP RevisionHub?</h5>\n' +
        '\n' +
        '<p>Yes, you do. But you can also download some handy PDF resources to use offline. Nice.</p>\n' +
        '\n' +
        '<h5>If I log in on a different device, will all my progress be saved?</h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress will be there waiting for you.</p>\n' +
        '\n' +
        '<h5>Can I clear my progress so far in CGP RevisionHub and start again?</h5>\n' +
        '\n' +
        "<p>There are no takie-backsies in CGP RevisionHub, so you can't clear your results and start again. But, you can have another go at any of the quizzes and they'll update to show your latest scores. Keep going, we believe in you!</p>\n" +
        '\n' +
        '<h5>Can I share my test results with other people?</h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means — Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?</p>\n" +
        '\n' +
        "<h5>What happens when I've answered all the questions?</h5>\n" +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams.</p>\n" +
        '\n' +
        '<h5>Will I always have access to CGP RevisionHub?</h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they'll be three whole years of bliss, we promise.</p>",
      VideoLink: 'https://www.youtube.com/embed/-TqrRoP-g9I?rel=0&modestbranding=1',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Quick Quiz',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Mistakes Quiz',
        ImagePath: '/assets/images/landing/your-mistakes-quiz.png',
        DestinationPage: 'Mistakes-Quiz',
        MenuType: MenuItemTypeEnum.MistakesQuiz,
      },
      {
        Text: 'Flashcards',
        ImagePath: '/assets/images/landing/flashcards.png',
        DestinationPage: 'Flashcards',
      },
      {
        Text: 'Poetry Readings',
        ImagePath: '/assets/images/landing/practice-audio.png',
        DestinationPage: 'Poetry-Readings',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],
    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      "There's plenty more revision where this came from! Take a look at some of our other revision books.",
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];
